import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BASE_API_URL } from '../../Components/config';
import AssignmentCard from "../AssignmentCard";

/**
 * A student's assignment on the classroom dashboard. Three states, matching the
 * design: outstanding work ("Assignment", with the due date), a submission
 * waiting on the teacher ("Pending Feedback"), and released feedback
 * ("Access Feedback", with the mark).
 */
const StudentAssignmentCard = ({
  userPaperAttemptGuid,
  completionStatus,
  submissionStatus,
  subjectCode,
  subjectName,
  classroomName,
  qualificationCode,
  boardName,
  assignmentName,
  scoredMarks,
  totalMarks,
  feedbackReleased = false,
}) => {
  const isCompleted = completionStatus === "COMPLETE";
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  const handleAccess = async () => {
    if (loading) return;

    try {
      setLoading(true);

      const paperDetailResponse = await axios.get(
        `${BASE_API_URL}/api/v1/user-paper-attempts/detail/${userPaperAttemptGuid}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      const {
        subject_name,
        paper_name,
        time_hour,
        time_min,
      } = paperDetailResponse.data;

      const formattedPaperName = `${paper_name}`;

      const questionsResponse = await axios.get(
        `${BASE_API_URL}/api/v1/user-paper-attempts/questions-with-attempt/${userPaperAttemptGuid}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      navigate("/my-papers/solve-paper", {
        state: {
          questions: questionsResponse.data,
          paper_Guid: userPaperAttemptGuid,
          subject_name,
          formattedPaperName,
          time_hour,
          time_min,
          paperMode: isCompleted ? "REVIEW" : "CLASSROOM",
          viewerRole: "STUDENT",
          feedbackReleased,
        },
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const statusLabel = feedbackReleased
    ? "Access Feedback"
    : isCompleted
    ? "Pending Feedback"
    : "Assignment";

  const hasMark =
    feedbackReleased && scoredMarks !== null && scoredMarks !== undefined && totalMarks;

  return (
    <AssignmentCard
      statusLabel={statusLabel}
      statusTone={feedbackReleased ? "green" : "red"}
      subject={subjectName || subjectCode}
      title={assignmentName}
      // The student card carries no dates (Figma 70:67) — just the status, the
      // subject and the name, plus the mark once feedback is released.
      note={hasMark ? `Mark : ${scoredMarks}/${totalMarks}` : undefined}
      onClick={handleAccess}
    />
  );
};

export default StudentAssignmentCard;
